import { Button, Form, TextBox, List } from 'devextreme-react';
import { GroupItem, Label, SimpleItem } from 'devextreme-react/form';
import React, { useEffect, useRef, useState } from 'react';
import './cusEnt-info.scss';
import { FormatLineNumber, FormatNumber } from '../../common';
import { InputOnlyNumber } from '../../common';
import CardBillAccountInfoPopupContainer from '../card-bill-list/card-bill-account-info-popup-container';
import CusEntInfoLinenumberPopupContainer from './cusEnt-info-linenumber-popup-container';

const CusEntInfo = ({
  cusEntInfo, lineNumberList, onClickAccountInfo, onClickUpdateLineNumber
}) => {
  //console.log('CorpInfo Load');

  return (
    <React.Fragment>
      <div className="cusEnt-info">
        <h2 className="main-title">업소고객정보</h2>
          <div className="cusEnt-info-detail">
          <Form
            formData={{cusEntInfo}}
            labelLocation={'left'}
            minColWidth={35}
            readOnly={true}
          >
              <SimpleItem>
                <Label text="업소명" />
                <TextBox
                    width="17rem"
                    readOnly={true}
                    stylingMode='outlined'
                    value={cusEntInfo.Name}
                />
              </SimpleItem>
              {/* <SimpleItem dataField="LineNumber" editorType="dxTextBox">
                <Label text="전화번호" />
                <TextBox
                  width="17rem"
                  readOnly={true}
                  stylingMode='outlined'
                  value={FormatLineNumber(cusEntInfo.LineNumber)}
                  onInput={(e) => InputOnlyNumber(e.event)}
                />
              </SimpleItem> */}
              <SimpleItem>
              <Label text="전화번호" />
              <List
                  className="cusEnt-LineNumber-List"
                  dataSource={lineNumberList}
                  displayExpr={(item) => `${FormatLineNumber(item.LineNumber)}`}
                  // displayExpr="LineNumber"
                  readOnly={true}
                  selectByClick='false'
              />
            </SimpleItem>
              <SimpleItem>
                <Label text="일반주소" />
                <TextBox
                  width="17rem"
                  readOnly={true}
                  stylingMode='outlined'
                  value={cusEntInfo.Dong}
                />
              </SimpleItem>
              <SimpleItem>
                <Label text="상세주소" />
                <TextBox
                  width="17rem"
                  readOnly={true}
                  stylingMode='outlined'
                  value={cusEntInfo.POIName}
                />
              </SimpleItem>
              <SimpleItem>
                <Label text="은행명" />
                <TextBox
                  width="17rem"
                  readOnly={true}
                  stylingMode='outlined'
                  value={cusEntInfo.BankName}
                />
              </SimpleItem>
              <SimpleItem>
                <Label text="계좌번호" />
                <TextBox
                  width="17rem"
                  readOnly={true}
                  stylingMode='outlined'
                  value={cusEntInfo.AccountNo}
                  onInput={(e) => InputOnlyNumber(e.event)}
                />
              </SimpleItem>
              <SimpleItem>
                <Label text="예금주" />
                <TextBox
                  width="17rem"
                  readOnly={true}
                  stylingMode='outlined'
                  value={cusEntInfo.BankOwnerName}
                />
              </SimpleItem>
          </Form>
        </div>
        <div className="cusEnt-info-Btn">
        <Button
          className="Btn"
          stylingMode="contained"
          type="default"
          text="전화번호수정"
          onClick={onClickUpdateLineNumber}
        />
        <Button
          className="Btn"
          stylingMode="contained"
          type="default"
          text="출금계좌편집"
          onClick={onClickAccountInfo}
        />
      </div>
    </div>
    <CardBillAccountInfoPopupContainer />
    <CusEntInfoLinenumberPopupContainer />
    </React.Fragment>
  );
};

export default React.memo(CusEntInfo);
